import { PlusIcon, TicketIcon } from 'lucide-react'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'sonner'
import useSWR from 'swr'

import {
  PreferenceButton,
  PreferenceCategory,
  PreferenceInfo,
  PreferenceLink,
  PreferenceScreen,
} from '../../components/Preference'
import { fetcher } from '../../lib/swr'
import { formatShortDate, type InviteRow, inviteStatus } from './invites'

export default function InvitesSettings() {
  const navigate = useNavigate()
  const invites = useSWR<InviteRow[]>('/api/invites', fetcher)
  const list = invites.data ?? []
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    if (invites.error) {
      toast.error(invites.error.message || 'Kon uitnodigingen niet laden')
    }
  }, [invites.error])

  async function makeInvite() {
    setBusy(true)
    try {
      const res = await fetch('/api/invites', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      })
      const data = await res.json()
      if (!res.ok) {
        toast.error(data.message || 'Mislukt')
        return
      }
      await invites.mutate()
      toast.success('Uitnodiging gemaakt')
      navigate(`/settings/invites/${data.id}`)
    } finally {
      setBusy(false)
    }
  }

  return (
    <PreferenceScreen title="Uitnodigingen" backHref="/settings">
      <PreferenceCategory filled>
        <PreferenceButton
          icon={<PlusIcon className="h-6 w-6" />}
          title="Nieuwe uitnodiging"
          summary="Maak een link of QR voor familie"
          onPress={makeInvite}
          disabled={busy}
        />
      </PreferenceCategory>

      <PreferenceCategory title="Alle uitnodigingen" filled>
        {list.length === 0 ? (
          <PreferenceInfo
            icon={<TicketIcon className="h-6 w-6" />}
            title="Nog geen uitnodigingen"
            summary="Maak er een om familie uit te nodigen."
          />
        ) : (
          list.map((invite) => {
            const status = inviteStatus(invite)
            return (
              <PreferenceLink
                key={invite.id}
                icon={<TicketIcon className="h-6 w-6" />}
                title={invite.code}
                summary={`${invite.note || 'Geen notitie'} · ${invite.claimsCount}/${invite.maxClaims} · tot ${formatShortDate(invite.expiresAt)} · ${status}`}
                href={`/settings/invites/${invite.id}`}
              />
            )
          })
        )}
      </PreferenceCategory>
    </PreferenceScreen>
  )
}
